import { useMutation, useQueryClient } from "@tanstack/react-query";

import { axiosInstanceNamek } from "@/service/Axios";
import { INamekError, NamekError } from "@/models";

import { MATERIALS_KEYS as KEYS } from "./queryKeys";

type CreateMaterialBody = {
  name: string;
};

const postCreateMaterial = (data: CreateMaterialBody) => {
  return axiosInstanceNamek
    .post("v1/materials", data)
    .then((response) => response.data)
    .catch((error) => {
      throw new NamekError(error.response?.data);
    });
};

export const useCreateMaterial = () => {
  const queryClient = useQueryClient();

  return useMutation<number, INamekError, CreateMaterialBody>({
    mutationFn: (data: CreateMaterialBody) => postCreateMaterial(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [KEYS.RECORDS] });
    },
  });
};
